<template>
  <a-drawer width="35%" :label-col="4" :wrapper-col="14" :visible="open" @close="onClose">
    <a-divider orientation="left">
      <b>{{ formTitle }}</b>
    </a-divider>
    <a-form-model ref="form" :model="form" :rules="rules">
      <a-form-model-item label="积分ID" prop="scoreId" >
        <a-input v-model="form.scoreId" placeholder="请输入积分ID" />
      </a-form-model-item>
      <a-form-model-item label="用户ID" prop="userId" >
        <a-input v-model="form.userId" placeholder="请输入用户ID" />
      </a-form-model-item>
      <a-form-model-item label="累计获取积分" prop="totalScore" >
        <a-input v-model="form.totalScore" placeholder="请输入累计获取积分" />
      </a-form-model-item>
      <a-form-model-item label="累计签到积分" prop="totalSignScore" >
        <a-input v-model="form.totalSignScore" placeholder="请输入累计签到积分" />
      </a-form-model-item>
      <a-form-model-item label="累计签到天数" prop="totalDays" >
        <a-input v-model="form.totalDays" placeholder="请输入累计签到天数" />
      </a-form-model-item>
      <a-form-model-item label="积分余额" prop="scoreBalance" >
        <a-input v-model="form.scoreBalance" placeholder="请输入积分余额" />
      </a-form-model-item>
      <a-form-model-item label="备注" prop="remark" >
        <a-input v-model="form.remark" placeholder="请输入内容" type="textarea" allow-clear />
      </a-form-model-item>
      <div class="bottom-control">
        <a-space>
          <a-button type="primary" :loading="submitLoading" @click="submitForm">
            保存
          </a-button>
          <a-button type="dashed" @click="cancel">
            取消
          </a-button>
        </a-space>
      </div>
    </a-form-model>
  </a-drawer>
</template>

<script>
import { getScore, addScore, updateScore } from '@/api/user/score'

export default {
  name: 'CreateForm',
  props: {
  },
  components: {
  },
  data () {
    return {
      submitLoading: false,
      formTitle: '',
      // 表单参数
      form: {
        id: null,

        scoreId: null,

        userId: null,

        totalScore: null,

        totalSignScore: null,

        totalDays: null,

        scoreBalance: null,

        createTime: null,

        remark: null,

      },
      // 1增加,2修改
      formType: 1,
      open: false,
      rules: {
        scoreId: [
          { required: true, message: '积分ID不能为空', trigger: 'blur' }
        ],
        userId: [
          { required: true, message: '用户ID不能为空', trigger: 'blur' }
        ],
        totalScore: [
          { required: true, message: '累计获取积分不能为空', trigger: 'blur' }
        ],
        totalSignScore: [
          { required: true, message: '累计签到积分不能为空', trigger: 'blur' }
        ],
        totalDays: [
          { required: true, message: '累计签到天数不能为空', trigger: 'blur' }
        ],
        scoreBalance: [
          { required: true, message: '积分余额不能为空', trigger: 'blur' }
        ]
      }
    }
  },
  filters: {
  },
  created () {
  },
  computed: {
  },
  watch: {
  },
  mounted () {
  },
  methods: {
    onClose () {
      this.open = false
      this.reset()
    },
    // 取消按钮
    cancel () {
      this.open = false
      this.reset()
    },
    // 表单重置
    reset () {
      this.formType = 1
      this.form = {
        id: null,
        scoreId: null,
        userId: null,
        totalScore: null,
        totalSignScore: null,
        totalDays: null,
        scoreBalance: null,
        createTime: null,
        remark: null,
      }
      this.$nextTick(() => {
        if(this.$refs.form){
          this.$refs.form.resetFields()
        }
      })
    },
    /** 新增按钮操作 */
    handleAdd (row) {
      this.reset()
      this.formType = 1
      this.open = true
      this.formTitle = '添加'
    },
    /** 修改按钮操作 */
    handleUpdate (row, ids) {
      this.reset()
      this.formType = 2
      const id = row ? row.id : ids
      getScore({"id":id}).then(response => {
        this.form = response.data
        this.open = true
        this.formTitle = '修改'
      })
    },
    /** 提交按钮 */
    submitForm: function () {
      this.$refs.form.validate(valid => {
        if (valid) {
          this.submitLoading = true
          if (this.form.id !== undefined && this.form.id !== null) {
            updateScore(this.form).then(response => {
              this.$message.success(
                '修改成功',
                3
              )
              this.open = false
              this.$emit('ok')
            }).finally(() => {
              this.submitLoading = false
            })
          } else {
            addScore(this.form).then(response => {
              this.$message.success(
                '新增成功',
                3
              )
              this.open = false
              this.$emit('ok')
            }).finally(() => {
              this.submitLoading = false
            })
          }
        } else {
          return false
        }
      })
    }
  }
}
</script>
